<template>
  <div class="core core-common">
    <van-field v-model="mobile" type="tel" label="手机号" />
    <van-field v-model="code" center clearable label="验证码" placeholder="请输入短信验证码">
      <template #button>
        <van-button size="small" type="primary" @click="sendSms">发送验证码</van-button>
      </template>
    </van-field>
    <van-button round block type="info" @click="login">
      Login
    </van-button>
    <!-- <van-form @submit="onSubmit">
      <van-field v-model="username" name="用户名" label="用户名" placeholder="用户名" :rules="[{ required: true, message: '请填写用户名' }]" />
      <van-field v-model="password" type="password" name="密码" label="密码" placeholder="密码" :rules="[{ required: true, message: '请填写密码' }]" />
      <div style="margin: 16px;">
       
      </div>
    </van-form> -->
  </div>
</template>

<script>
export default {
  name: 'CoreCommonLogin',
  data() {
    return {
      api: $$.module.core.$api,
      mobile: '',
      code: '',
      random: ''
    };
  },
  methods: {
    sendSms() {
      this.api.sendSms({
        data: { mobile: this.mobile },
        success: (data) => {
          this.random = data;
        }
      });
    },
    login() {
      this.api.login({
        data: { mobile: this.mobile, checkCode: this.code, checkCodeKeyId: this.random },
        success: (data) => {
          $$.token.set(data);
        }
      });
    }
  }
};
</script>
